<template>
  <div>
    <BaseTitle :title="$t(isEditable ? 'content.template_integ_view' : edit ? 'content.template_integ_edit' : 'content.template_integ_create')" />

    <form @submit.prevent="submit">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="mb-8">
            <div class="pa-8">
              <v-row>
                <v-col class="md-6">
                  <form-group :name="$t('content.integ_name')" :validator="$v.form.integrationName">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.integrationName"
                        :disabled="isEditable"
                        v-bind="attrs"
                        :label="$t('content.integ_name')"
                        @input="$v.form.integrationName.$touch()"
                        @blur="$v.form.integrationName.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col class="md-6">
                  <form-group :name="$t('content.select_template')" no-gutter :validator="$v.form.eraporTemplateId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-bind="attrs"
                        v-model="form.eraporTemplateId"
                        item-value="eraporTemplateId"
                        :disabled="isEditable"
                        item-text="name"
                        :loading="loadingTemplate"
                        :items="templateGroupList"
                        :label="$t('content.select_template')"
                        @change="getTemplate"
                        @input="$v.form.eraporTemplateId.$touch()"
                        @blur="$v.form.eraporTemplateId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-card class="mb-5">
            <div class="pa-8">
              <v-row>
                <v-col class="md-12">
                  <form-group :name="$t('menu.class')" no-gutter :validator="$v.form.classroomId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-bind="attrs"
                        v-model="form.classroomId"
                        item-value="classroomId"
                        :disabled="isEditable"
                        item-text="name"
                        :items="listClassroom"
                        :label="$t('menu.class')"
                        @change="getCourse"
                        @input="$v.form.classroomId.$touch()"
                        @blur="$v.form.classroomId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-data-table
                v-model="form.attendances"
                :headers="headerCourse"
                :disabled="isEditable"
                :items="listCourse"
                item-key="courseId"
                value="courseId"
                :show-select="!isEditable"
                hide-default-footer
                disable-pagination
                class="table-custom"
              >
                <template #no-data><NoData /></template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <!-- list group template course -->
      </v-row>
      <!-- <v-card class="mb-5" v-for="(item, parent) in form.eraporGroupTemplates" :key="parent">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">{{ item.name }}</div>
              <v-spacer />
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <template>
            <div class="pa-5 mt-6" v-for="(datas, child) in item.eraporTemplateCourses" :key="child">
              <div>
                <div class="pa-5 d-flex justiy-space-between align-items section-header active">
                  <div class="student-title">
                    {{ datas.courseName }}
                  </div>
                </div>
                <div class="ml-5 mt-3 mr-5">
                  <v-row>
                    <v-col md="12">
                      <form-group
                        :name="$t('menu.course')"
                        :validator="$v.form.eraporGroupTemplates.$each.$iter[parent].eraporTemplateCourses.$each.$iter[child].courseId"
                        no-gutter
                      >
                        <template slot-scope="{ attrs }">
                          <v-select
                            v-bind="attrs"
                            v-model="datas.courseId"
                            item-value="courseId"
                            item-text="name"
                            :disabled="isEditable"
                            :items="listCourse"
                            :loading="loadingAssignment"
                            @blur="$v.form.eraporGroupTemplates.$each.$iter[parent].eraporTemplateCourses.$each.$iter[child].courseId.$touch()"
                            @input="$v.form.eraporGroupTemplates.$each.$iter[parent].eraporTemplateCourses.$each.$iter[child].courseId.$touch()"
                            :label="$t('menu.course')"
                            @change="getAssignment(datas.courseId, parent, child)"
                          />
                        </template>
                      </form-group>
                    </v-col>
                  </v-row>
                  <v-data-table
                    v-model="datas.assignments"
                    :headers="headerAssignment"
                    :items="datas.listAssignment"
                    item-key="assignmentId"
                    value="assignmentId"
                    :show-select="!isEditable"
                    hide-default-footer
                    disable-pagination
                    class="table-custom"
                  >
                    <template #item.assignmentTypeId="{ item }">
                      <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                      <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                      <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                      <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                    </template>
                    <template #no-data><NoData /></template>
                  </v-data-table>
                </div>
              </div>
            </div>
          </template>
        </slide-box>
      </v-card> -->
      <div class="d-flex justify-end align-center">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" class="btn-primary-custom" v-if="!isEditable" @click="submit" :loading="loading">
          {{ $t('submit') }}
        </v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import NoData from '@/components/table/NoData';
import ripple from 'vuetify/lib/directives/ripple';
// import SlideBox from '@/components/SlideBox';

export default {
  name: 'CreateEditIntegrationTemplate',
  directives: {
    ripple
  },
  components: {
    BaseTitle,
    // SlideBox,
    NoData
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        integrationName: { required },
        eraporTemplateId: { required },
        classroomId: { required },
        attendances: { required }
        // eraporGroupTemplates: {
        //   required,
        //   $each: {
        //     eraporTemplateCourses: {
        //       $each: {
        //         courseId: { required }
        //       }
        //     }
        //   }
        // }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    headerCourse() {
      return [{ text: this.$t('content.attendance_course'), sortable: false, value: 'name' }];
    },
    headerAssignment() {
      return [
        { text: this.$t('content.assignment_name'), sortable: false, value: 'assignmentTitle' },
        { text: this.$t('content.assignment_type'), sortable: false, value: 'assignmentTypeId' }
      ];
    }
  },
  data: () => ({
    form: {
      integrationName: '',
      eraporTemplateId: '',
      classroomId: '',
      attendances: [],
      eraporGroupTemplates: []
    },
    templateGroupList: [],
    listClassroom: [],
    listCourse: [],
    templateGroup: '',
    loadingButton: false,
    loadingGroup: false,
    loadingTemplate: false,
    loadingAssignment: false,
    loading: false,
    edit: false,
    eraporGroupTemplates: []
  }),
  methods: {
    getData() {
      this.$store.dispatch('TemplateErapor/fetchDetailIntegartion', this.$route.params.id).then(ras => {
        const payload = { id: ras.classroomId, search: '' };
        this.$store
          .dispatch(`${!this.isEditable ? 'TemplateErapor/fetchClass' : 'SchoolClass/fetchList'}`, {
            eraporTemplateId: ras.eraporTemplateId,
            eraporIntegrationTemplateId: this.$route.params.id,
            search: ''
          })
          .then(ras => {
            this.listClassroom = ras;
          })
          .finally(() => {
            this.loading = true;
            this.$store
              .dispatch(`${!this.isEditable ? 'CourseList/fetchList' : 'CourseSchool/fetchList'}`, payload)
              .then(res => {
                this.listCourse = !this.isEditable ? res : ras.attendances;
              })
              .finally(() => {
                this.loading = false;
                if (!ras.eraporGroupTemplates.length) {
                  Object.keys(this.form).forEach(form => {
                    this.form[form] = ras[form];
                  });
                }

                ras.eraporGroupTemplates.forEach(datas => {
                  datas.eraporTemplateCourses.forEach(data => {
                    var chkObj = a => Object.values(a).every(a => a.length === 0);
                    datas.isEmpty = chkObj(data.assignments);
                    this.$store
                      .dispatch('Assignment/fetchListFilter', {
                        classId: ras.classroomId,
                        courseId: data.courseId
                      })
                      .then(detes => {
                        data.listAssignment = detes.filter(data => data.published === true);
                      })
                      .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
                      .finally(() => {
                        setTimeout(() => {
                          Object.keys(this.form).forEach(form => {
                            this.form[form] = ras[form];
                          });
                        }, 200);
                      });
                  });
                });
              });
          });
      });
    },
    // getAssignment(item, parent, child) {
    //   this.loadingAssignment = true;
    //   this.$store
    //     .dispatch('Assignment/fetchListFilter', {
    //       classId: this.form.classroomId,
    //       courseId: item
    //     })
    //     .then((res) => {
    //       // this.form.eraporGroupTemplates[parent].eraporTemplateCourses[child].assignments = [];
    //       // this.form.eraporGroupTemplates[parent].eraporTemplateCourses[child].listAssignment = res.filter(data => data.published === true);
    //     })
    //     .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
    //     .finally(() => (this.loadingAssignment = false));
    // },
    getTemplateGroup() {
      this.$store.dispatch('TemplateErapor/fetchListTemplateGroup').then(ras => {
        this.templateGroupList = ras;
      });
    },
    getTemplate() {
      this.loadingTemplate = true;
      this.$store
        .dispatch('TemplateErapor/fetchDetail', this.form.eraporTemplateId)
        .then(ras => {
          ras.eraporGroupTemplates.forEach(datas =>
            datas.eraporTemplateCourses.forEach(data => {
              data.listAssignment = [];
              data.assignments = [];
              data.courseId = '';
              delete data.description;
              delete data.minimumCriteria;
              delete data.eraporPredicates;
            })
          );
          this.form.eraporGroupTemplates = ras.eraporGroupTemplates;
        })
        .finally(() => {
          this.loadingTemplate = false;
          this.getClass();
        });
    },
    getClass() {
      this.$store
        .dispatch('TemplateErapor/fetchClass', { eraporTemplateId: this.form.eraporTemplateId, eraporIntegrationTemplateId: this.$route.params.id })
        .then(ras => {
          this.listClassroom = ras;
        });
    },
    getCourse() {
      this.form.attendances = [];
      const payload = { id: this.form.classroomId };
      this.loading = true;
      this.$store
        .dispatch('CourseList/fetchList', payload)
        .then(ras => {
          this.listCourse = ras;
        })
        .finally(() => (this.loading = false));
      this.form.attendances = [];
      this.loading = true;
      this.$store
        .dispatch('TemplateErapor/fetchCourseList', this.form.classroomId)
        .then(ras => {
          this.listCourse = ras;
        })
        .finally(() => (this.loading = false));
    },
    submit() {
      // function hasDuplicates(arr) {
      //   var counts = [];

      //   for (var i = 0; i <= arr.length; i++) {
      //     if (counts[arr[i]] === undefined) {
      //       counts[arr[i]] = 1;
      //     } else {
      //       return true;
      //     }
      //   }
      //   return false;
      // }
      // let checker = arr => arr.every(v => v.isEmpty === false);
      if (this.form.attendances.length === 0) {
        this.$store.dispatch('general/showErrorNotification', { message: 'Attendance Course Required' });
      }

      // if (!checker(this.form.eraporGroupTemplates)) {
      //   this.$store.dispatch('general/showErrorNotification', { message: 'Group Course Assignment Required' });
      // } else {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }

      // this.form.eraporGroupTemplates.forEach(datas => {
      //   datas.listCourse = datas.eraporTemplateCourses.reduce((acc, row) => {
      //     acc.push(row.courseId);
      //     return acc;
      //   }, []);
      // });

      // var courseParent = [];
      // for (var v of this.form.eraporGroupTemplates) {
      //   courseParent.push(...v.listCourse);
      // }
      // this.form.listCourse = courseParent;

      // if (hasDuplicates(this.form.listCourse)) {
      //   this.$store.dispatch('general/showErrorNotification', { message: 'Course Duplicate , please change' });
      // } else {
      const input = {
        integrationName: this.form.integrationName,
        eraporTemplateId: this.form.eraporTemplateId,
        classroomId: this.form.classroomId,
        attendances: this.form.attendances
      };

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...input };

      this.$store
        .dispatch(`TemplateErapor/${this.edit ? 'updateIntegration' : 'saveIntegration'}`, payload)
        .then(() =>
          this.$router.push({
            name: this.edit ? 'eRaporIntegUpdateSuccess' : 'eRaporIntegSuccess'
          })
        )
        .finally(() => (this.loading = false));
      // }
      // }
    },
    back() {
      this.$router.push({ name: 'eRaporGeneratorIndex' });
    }
  },
  created() {
    this.getTemplateGroup();
    // this.getClass();
    if (this.$route.params.id) {
      this.getData();
      // this.getTemplate();
      this.edit = true;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.card-radio {
  background-color: #b2ebd0;
  border-radius: 8px;
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
</style>
